import React from 'react';
import { Search, Filter } from 'lucide-react';
import { statusOptions, datePresetOptions } from '../utils/invoiceConstants';
import DateTimePicker from '../../DateTimePicker';

const InvoiceFilters = ({
  searchTerm,
  onSearch,
  filters,
  onFilterChange,
  showFilters,
  onToggleFilters,
  onClearFilters
}) => {
  const hasActiveFilters = filters.status || filters.datePreset;

  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-4 mb-6">
      <div className="flex flex-row gap-2 md:gap-4">
        <div className="flex-1">
          <div className="relative">
            <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
            <input
              type="text"
              placeholder="Search invoices..."
              value={searchTerm}
              onChange={(e) => onSearch(e.target.value)}
              className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-pest-blue focus:border-transparent"
            />
          </div>
        </div>

        {/* Desktop: full button */}
        <button
          onClick={onToggleFilters}
          className={`hidden md:flex btn btn-md btn-outline ${hasActiveFilters ? '!border-pest-blue !text-pest-blue' : ''}`}
        >
          <Filter size={16} />
          <span>Filters</span>
          {hasActiveFilters && <span className="bg-pest-blue text-white text-xs rounded-full w-5 h-5 flex items-center justify-center">!</span>}
        </button>

        {/* Mobile: icon-only button */}
        <button
          onClick={onToggleFilters}
          className={`md:hidden flex items-center justify-center w-10 h-10 rounded-lg border ${hasActiveFilters ? 'border-pest-blue text-pest-blue' : 'border-gray-300 text-gray-500'}`}
        >
          <Filter size={18} />
        </button>
      </div>

      {showFilters && (
        <div className="mt-4 pt-4 border-t border-gray-200">
          <div className="grid grid-cols-2 gap-4">
            <select
              value={filters.status}
              onChange={(e) => onFilterChange('status', e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-pest-blue focus:border-transparent"
            >
              {statusOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>

            <select
              value={filters.datePreset || ''}
              onChange={(e) => onFilterChange('datePreset', e.target.value)}
              className="border border-gray-300 rounded-lg px-3 py-2 focus:ring-2 focus:ring-pest-blue focus:border-transparent"
            >
              {datePresetOptions.map(option => (
                <option key={option.value} value={option.value}>
                  {option.label}
                </option>
              ))}
            </select>
          </div>

          {filters.datePreset && (
            <div className="grid grid-cols-2 gap-4 mt-4">
              <div>
                <label className="block text-xs text-gray-500 mb-1">From</label>
                <DateTimePicker
                  value={filters.dateFrom}
                  onChange={(val) => onFilterChange('dateFrom', val)}
                  dateOnly
                  className="w-full"
                />
              </div>
              <div>
                <label className="block text-xs text-gray-500 mb-1">To</label>
                <DateTimePicker
                  value={filters.dateTo}
                  onChange={(val) => onFilterChange('dateTo', val)}
                  dateOnly
                  className="w-full"
                />
              </div>
            </div>
          )}

          <div className="mt-4 flex justify-end">
            <button
              onClick={onClearFilters}
              className="text-sm text-gray-600 hover:text-gray-800"
            >
              Clear all filters
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default InvoiceFilters;
